import { auth } from "@@firebase";

export async function logout() {
  await auth.signOut();
}
